// extracted by mini-css-extract-plugin
export default {"cb":"cb","cb_input":"cb_input","cb_label":"cb_label","cb_input_edit":"cb_input_edit","cb_font":"cb_font"};